import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, doc, setDoc, deleteDoc } from 'firebase/firestore';
import { Heart, ShoppingBag } from 'lucide-react';
import { useAuthContext } from '../hooks/useAuthContext';
import { db } from '../firebase/config';
import { useNavigate } from 'react-router-dom';
import './Saved.css';

const Saved = () => {
  const [savedProducts, setSavedProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useAuthContext();
  const navigate = useNavigate();

  const addToCart = async (product) => {
    if (!user) {
      alert("Please log in to add items to your bag.");
      return;
    }

    try {
      const bagItemRef = doc(db, 'myBag', user.uid, 'items', product.id);
      await setDoc(bagItemRef, { ...product, quantity: 1 });
      
      // Optional: You might want to remove the product from saved items after adding to bag
      await handleRemoveSavedProduct(product.id);
      navigate('/mybag');
    } catch (error) {
      console.error('Error adding product to bag:', error);
      alert('Failed to add product to bag. Please try again.');
    }
  };

  useEffect(() => {
    const fetchSavedProducts = async () => {
      if (!user) {
        setIsLoading(false);
        return;
      }

      try {
        const savedProductsRef = collection(db, 'savedProducts', user.uid, 'items');
        const q = query(savedProductsRef);
        const querySnapshot = await getDocs(q);
        
        const products = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        
        setSavedProducts(products);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching saved products:', error);
        setIsLoading(false);
      }
    };

    fetchSavedProducts();
  }, [user]);

  const handleRemoveSavedProduct = async (productId) => {
    try {
      await deleteDoc(doc(db, 'savedProducts', user.uid, 'items', productId));
      setSavedProducts(savedProducts.filter(product => product.id !== productId));
    } catch (error) {
      console.error('Error removing saved product:', error);
    }
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner-overlay">
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <div className="saved-products-error">Please log in to view saved products.</div>;
  }

  return (
    <div className="saved-products-container">
      <h1 className="saved-products-title">Saved Products</h1>
      
      {savedProducts.length === 0 ? (
        <div className="saved-products-empty">
          <Heart className="empty-icon" size={64} strokeWidth={1.5} />
          <p>No products saved yet</p>
          <p>Explore our collection and start saving your favorite items!</p>
        </div>
      ) : (
        <div className="saved-products-grid">
          {savedProducts.map(product => (
            <div key={product.id} className="saved-product-card">
              <img 
                src={product.images[0]} 
                alt={product.name} 
                className="saved-product-image"
              />
              <div className="saved-product-details">
                <h3>{product.name}</h3>
                <p>&#8358;{product.price.toFixed(2)}</p>
                <div className="saved-product-actions">
                  <button 
                    onClick={() => handleRemoveSavedProduct(product.id)}
                    className="remove-saved-product-btn"
                  >
                    Remove
                  </button>
                  </div><br />
                  <div className='saved-product-actions'>
                  <button 
                    onClick={() => addToCart(product)}
                    className="add-to-bag-btn"
                  >
                    <ShoppingBag className="shopping-bag-icon" />
                    Add to Bag
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Saved;